import logoIcon from "@/shared/assets/logo/logo-icon.svg";

export async function generateQRWithLogo(url: string, logoSize = 85): Promise<string> {
  const qrSize = 316;

  const qrImg = new Image();
  qrImg.crossOrigin = "anonymous";
  qrImg.src = `https://api.qrserver.com/v1/create-qr-code/?size=${qrSize}x${qrSize}&ecc=H&data=${encodeURIComponent(url)}`;

  await new Promise((resolve, reject) => {
    qrImg.onload = resolve;
    qrImg.onerror = reject;
  });

  const logoImg = new Image();
  logoImg.src = logoIcon;

  await new Promise((resolve, reject) => {
    logoImg.onload = resolve;
    logoImg.onerror = reject;
  });

  const canvas = document.createElement("canvas");
  canvas.width = qrSize;
  canvas.height = qrSize;
  const ctx = canvas.getContext("2d");
  if (!ctx) throw new Error("Failed to get canvas context");

  ctx.drawImage(qrImg, 0, 0, qrSize, qrSize);

  const centerX = qrSize / 2;
  const centerY = qrSize / 2;
  ctx.fillStyle = "white";
  ctx.beginPath();
  ctx.arc(centerX, centerY, logoSize / 2 + 1, 0, 2 * Math.PI);
  ctx.fill();

  ctx.drawImage(logoImg, centerX - logoSize / 2, centerY - logoSize / 2, logoSize, logoSize);

  return canvas.toDataURL("image/png");
}

export function getQRFallbackUrl(mobileUrl: string): string {
  return `https://api.qrserver.com/v1/create-qr-code/?size=316x316&ecc=H&data=${encodeURIComponent(mobileUrl)}`;
}
